
// Angular
export const SCOPE_DESTROY = '$destroy';

// Ionic
export const IONIC_VIEW_ENTER = '$ionicView.enter';
export const IONIC_VIEW_BEFORE_LEAVE = '$ionicView.beforeLeave';
export const IONIC_VIEW_LEAVE = '$ionicView.leave';
export const MODAL_SHOWN = 'modal.shown';
export const MODAL_HIDDEN = 'modal.hidden';



// WEBPACK FOOTER //
// ./src/js/config/constants/view-events.js